const TOOLTIP = 'A visible divider between menu items.';
/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    const workspace = blocklyBlock.workspace;
    const blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
}
function convertCustomFieldsToCode(code /*, blocklyBlock*/) {
    return code;
}
module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
